export const TOOLTIP_CONFIG = {
  delay: 2000,
  position: 'right',
};
